import axios from 'axios'
import { TokenService } from '../services/storage.service'
import store from '../store'
import posthog from "posthog-js";

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    _interceptor: null,

    setHeader() {
        const token = TokenService.getToken();
        if ( token ) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        }
        else {
            axios.defaults.headers.common["Authorization"] = null;
        }
        axios.defaults.headers.common["TimezoneOffset"] = new Date().getTimezoneOffset() / 60;
        let extra = TokenService.getExtraInfo();
        let sharedAccount = TokenService.getSharedAccount();
        if ( sharedAccount ) {

            axios.defaults.headers.common["Shared-Account"] = sharedAccount;

        }
        if ( extra && extra.access && extra.access === 'admin' && !!extra.demo ) {

            axios.defaults.headers.common["isdemo"] = 1;

        }
        if ( version ) {

            axios.defaults.headers.common["version"] = version;

        }

        const postHogId = posthog.get_distinct_id();

        if ( postHogId ) {
       
            axios.defaults.headers.common["posthog"] = postHogId;

        }
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource,data,label) {
        this.setHeader();
        return axios.get(resource,data)
    },

    post(resource, data, ops) {
        this.setHeader();
        return axios.post(resource, data, ops)
    },

    put(resource, data) {
        this.setHeader();
        return axios.put(resource, data)
    },

    delete(resource) {
        this.setHeader();
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        return axios(data)
    },

    mountInterceptor() {
        
        this._interceptor = axios.interceptors.response.use(
            (response) => {
                if ( typeof response.data === 'object' && response.data && typeof response.data.globalMessage !== 'undefined' ) {
                    store.commit('general/printGlobalMessage',response.data.globalMessage);
                }
                return response; 
            },
            async (error) => {

                if (error.request.status == 401) {
                    if (error.config.url.includes('users/refresh-token')) {
                        // Refresh token has failed. Logout the user
                        store.commit('general/updateLoadingText','');
                        store.dispatch('auth/logoutForce')
                        throw error
                    } else {
                        // Refresh the access token
                        try{
                            await store.dispatch('auth/refreshToken')
                            store.commit('general/updateLoadingText','');
                            // Retry the original request

                            let data = error.config.data, data2;

                            try { data2=JSON.parse(data);}catch(err){data2=data};

                            return this.customRequest({
                                method: error.config.method,
                                url: error.config.url,
                                data: data2
                            })
                        } catch (e) {
                            // Refresh has failed - reject the original request
                            throw error
                        }
                    }
                }

                if (error.request.status == 403) {
                    store.commit('general/updateLoadingText','');
                    store.dispatch('auth/logoutForce',error.response.data || null)
                   
                    throw error
                }

                // If error was not 401 just reject as is
                throw error
            }
        )
    },

    unmountInterceptor() {
        // Eject the interceptor
        axios.interceptors.response.eject(this._interceptor)
    }
}

export default ApiService